module.exports = {
  "country": "TR",
  "artist": "Can Bonomo",
  "song": "Love Me Back",
  "year": "2012",
  "place": "7",
  "spotify": "6Sa2IXbpv1TTpYdBY0dJXH"
};